module.exports = __webpack_public_path__ + "static/img_4801-bb306e164ceff91d64cb2a1ce91ef2ab.webp";